/**
 * Número CNJ (NNNNNNN-DD.AAAA.J.TR.OOOO) — mesma validação da API
 * (dígito verificador módulo 97).
 */
export function cnjDigits(raw: string): string {
  return raw.replace(/\D/g, '')
}

export function isValidCnj(raw: string): boolean {
  const digits = cnjDigits(raw)
  if (digits.length !== 20) return false
  const base = digits.slice(0, 7) + digits.slice(9, 20) + '00'
  let remainder = 0
  for (const char of base) remainder = (remainder * 10 + Number(char)) % 97
  return String(98 - remainder).padStart(2, '0') === digits.slice(7, 9)
}

export function maskCnj(raw: string): string {
  const d = cnjDigits(raw).slice(0, 20)
  const parts = [d.slice(0, 7), d.slice(7, 9), d.slice(9, 13), d.slice(13, 14), d.slice(14, 16), d.slice(16, 20)]
  const seps = ['', '-', '.', '.', '.', '.']
  return parts.reduce((acc, part, i) => (part ? acc + seps[i] + part : acc), '')
}
